import React from 'react';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';
import { Badge, Collapse } from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
// import { Box } from 'react-feather';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { createStructuredSelector } from 'reselect';

import routes, { routesByRole } from 'containers/App/routes';
import { makeSelectLayout, makeSelectSidebar, makeSelectUserRole, makeSelectLocation } from 'containers/App/selectors';

import logoImg from './logo.png';
import BeaconIcon from './BeaconIcon';
import { ROLE_USER } from 'containers/App/constants';

export const SidebarCategory = withRouter(
  ({ name, badgeColor, badgeText, beaconIcon, icon, isOpen, children, onClick, location, to }) => {
    const getSidebarItemClass = path => {
      return location.pathname.indexOf(path) !== -1 || (location.pathname === '/' && path === '/dashboard')
        ? 'active'
        : '';
    };

    return (
      <li className={'sidebar-item ' + getSidebarItemClass(to)}>
        <span
          data-toggle="collapse"
          className={'sidebar-link ' + (!isOpen ? 'collapsed' : '')}
          onClick={onClick}
          aria-expanded={isOpen ? 'true' : 'false'}
        >
          {icon ? <FontAwesomeIcon icon={icon} size="lg" fixedWidth className="align-middle mr-3" /> : null}
          {beaconIcon ? (
            <BeaconIcon
              fill="currentColor"
              className="svg-inline--fa fa-chart-bar fa-w-16 fa-fw fa-lg align-middle mr-3"
            />
          ) : null}
          <span className="align-middle">{name}</span>
          {badgeColor && badgeText ? (
            <Badge color={badgeColor} size={18} className="sidebar-badge">
              {badgeText}
            </Badge>
          ) : null}
        </span>
        <Collapse isOpen={isOpen}>
          <ul id="item" className={'sidebar-dropdown list-unstyled'}>
            {children}
          </ul>
        </Collapse>
      </li>
    );
  },
);

export const SidebarItem = withRouter(({ name, badgeColor, badgeText, beaconIcon, icon, location, to }) => {
  const getSidebarItemClass = path => {
    if (location.pathname.includes('/beacons-management/app')) {
      return location.pathname.includes(path) ? 'active' : '';
    }
    return location.pathname === path ? 'active' : '';
  };

  return (
    <li className={'sidebar-item ' + getSidebarItemClass(to)}>
      <NavLink to={to} className="sidebar-link" activeClassName="active">
        {icon ? <FontAwesomeIcon icon={icon} size="lg" fixedWidth className="align-middle mr-3" /> : null}
        {beaconIcon ? (
          <BeaconIcon
            fill="currentColor"
            className="svg-inline--fa fa-chart-bar fa-w-16 fa-fw fa-lg align-middle mr-3"
          />
        ) : null}
        {name}
        {badgeColor && badgeText ? (
          <Badge color={badgeColor} size={18} className="sidebar-badge">
            {badgeText}
          </Badge>
        ) : null}
      </NavLink>
    </li>
  );
});

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    /* Open collapse element that matches current url */
    const pathName = this.props.location.pathname;

    routes.forEach((route, index) => {
      const isActive = pathName.indexOf(route.path) === 0;
      const isOpen = route.open;
      const isHome = route.isHome && pathName === '/';

      this.state[index] = isActive || isOpen || isHome;
    });
  }

  toggle = index => {
    // Collapse all elements
    Object.keys(this.state).forEach(
      item =>
        this.state[index] ||
        this.setState(() => ({
          [item]: false,
        })),
    );

    // Toggle selected element
    this.setState(state => ({
      [index]: !state[index],
    }));
  };

  render() {
    const { sidebar, userRole /*, layout */ } = this.props;
    const availabelRoutes = routesByRole(userRole || ROLE_USER);

    return (
      <nav className={'sidebar' + (!sidebar.isOpen ? ' toggled' : '') + (sidebar.isSticky ? ' sidebar-sticky' : '')}>
        <div className="sidebar-content">
          <PerfectScrollbar>
            <a className="sidebar-brand" href="/">
              {/* <Box className="align-middle text-primary" size={24} /> <span className="align-middle">Parousya</span> */}
              <img className="img-fluid" width="100%" src={logoImg} alt="Parousya" />
            </a>

            <ul className="sidebar-nav">
              {availabelRoutes.map((category, index) => {
                if (category.noMenu) {
                  return null;
                }

                if (category.menuComponent) {
                  return (
                    <React.Fragment key={index}>
                      {category.header ? <li className="sidebar-header">{category.header}</li> : null}
                      <category.menuComponent items={category.children} />
                    </React.Fragment>
                  );
                }

                return (
                  <React.Fragment key={index}>
                    {category.header ? <li className="sidebar-header">{category.header}</li> : null}

                    {category.children ? (
                      <SidebarCategory
                        name={category.name}
                        badgeColor={category.badgeColor}
                        badgeText={category.badgeText}
                        icon={category.icon}
                        to={category.path}
                        isOpen={this.state[index]}
                        onClick={() => this.toggle(index)}
                      >
                        {category.children.map((route, index) => (
                          <SidebarItem
                            key={index}
                            name={route.name}
                            to={route.path}
                            badgeColor={route.badgeColor}
                            badgeText={route.badgeText}
                          />
                        ))}
                      </SidebarCategory>
                    ) : (
                      <SidebarItem
                        name={category.name}
                        to={category.path}
                        icon={category.icon}
                        beaconIcon={category.beaconIcon}
                        badgeColor={category.badgeColor}
                        badgeText={category.badgeText}
                      />
                    )}
                  </React.Fragment>
                );
              })}
            </ul>

            {/* {!layout.isBoxed && !sidebar.isSticky ? (
              <div className="sidebar-bottom d-none d-lg-block">
                <div className="media">
                  <img
                    className="rounded-circle mr-3"
                    src="/images/default-avatar.png"
                    alt="Chris Wood"
                    width="40"
                    height="40"
                  />
                  <div className="media-body">
                    <h5 className="mb-1">Chris Wood</h5>
                    <div>
                      <FontAwesomeIcon icon={faCircle} className="text-success" /> Online
                    </div>
                  </div>
                </div>
              </div>
            ) : null} */}
          </PerfectScrollbar>
        </div>
      </nav>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  layout: makeSelectLayout(),
  sidebar: makeSelectSidebar(),
  userRole: makeSelectUserRole(),
  location: makeSelectLocation(),
});

export default connect(mapStateToProps)(Sidebar);
